<template>
  <div>
    <footer class="footer is-site-coler">
      <article class="level is-mobile">
        <section class="level-item">
          <button class="button is-small is-text" type="button" v-on:click="go_To_How">Iventerの使い方</button>
        </section>
        <section class="level-item">
          <button class="button is-small is-text" type="button" v-on:click="go_To_Terms">利用規約</button>
        </section>
        <address class="level-item">
          <p>@there_you_hide</p>
        </address>
      </article>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data: function() {
    return {};
  },
  methods: {
    go_To_Terms: function() {
      this.$router.push({
        name: "Terms"
      });
    },
    go_To_How: function() {
      this.$router.push({
        name: "How"
      });
    }
  }
};
</script>

<style>
.is-footer-height {
  max-height: 10%;
}

.is-footer-content-size {
  min-height: 100%;
}
</style>
